import {
    ComplianceStatus,
    TprmRequirementType,
    ExceptionInput,
    ExceptionLevel,
    ExceptionType,
} from '@evidentid/tprm-portal-lib/models/entity-details';

export function createEntityLevelException(
    type?: ExceptionType,
    status?: ComplianceStatus,
): ExceptionInput {
    return {
        level: ExceptionLevel.insured,
        type: type || ExceptionType.permanent,
        status: status || ComplianceStatus.compliant,
    };
}

export function createRequirementLevelException({
    requirementType,
    type,
    status,
    instanceId,
}: {
    requirementType: TprmRequirementType;
    instanceId?: string | null;
    type?: ExceptionType;
    status?: ComplianceStatus;
}): ExceptionInput {
    return {
        coverageType: requirementType,
        instanceId,
        level: ExceptionLevel.requirementInstance,
        type: type || ExceptionType.permanent,
        status: status || ComplianceStatus.compliant,
    };
}

export function createCriterionLevelException({
    requirementType,
    criterionId,
    instanceId,
    type,
    status,
}: {
    requirementType: TprmRequirementType;
    instanceId?: string | null;
    criterionId: string;
    type?: ExceptionType;
    status?: ComplianceStatus;
}): ExceptionInput {
    return {
        coverageType: requirementType,
        criterionId,
        instanceId,
        level: ExceptionLevel.coverageCriterion,
        type: type || ExceptionType.permanent,
        status: status || ComplianceStatus.compliant,
    };
}

export function createEvaluateEntityLevelException(
    evaluatedEntityId: string,
    type?: ExceptionType,
    status?: ComplianceStatus,
): ExceptionInput {
    return {
        evaluatedEntityId,
        level: ExceptionLevel.evaluatedEntity,
        type: type || ExceptionType.permanent,
        status: status || ComplianceStatus.compliant,
    };
}
